module.exports = __webpack_public_path__ + "static/media/hide-project-button.6572183f.svg";